import { useContext } from "react";
import { setFeatureFlags } from "@actions/FeatureFlags";
import { FeatureFlagContext } from "@contexts/FeatureFlagProvider";
import { getEnabledFeatures } from "@helpers/FeatureFlag";

const useFeatureFlag = () => {
  const context = useContext(FeatureFlagContext);

  if (!context) {
    throw new Error("useFeatureFlag must be used within FeatureFlagProvider");
  }

  const [state, dispatch] = context;

  const getFeatureFlags = async () => {
    const featureFlags = getEnabledFeatures();
    dispatch(setFeatureFlags(featureFlags));
  };

  return {
    getFeatureFlags,
    ...state,
  };
};

export default useFeatureFlag;
